import React, { useEffect, useState } from "react";
import {
  Container,
  Row
} from "react-bootstrap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "../css/home.css";
import { getcmsAction, getNewCmsAction } from "../../../Action/user.action";

const TermsAndConditions = () => {
  const [termsandconditionlist, settermsandconditionlist] = useState({
    termsAndCondition: ""
  });
  useEffect(() => {
    getTermsAndConditionFunc();
    // setcondition();
  }, []);

  const getTermsAndConditionFunc = async () => {
    let res = await getNewCmsAction("termsandconditions");
    if (res.success && res.data?.cms_value) {
      settermsandconditionlist({ termsAndCondition: res.data.cms_value });
    } else {
      console.error("Failed to fetch CMS content");
    }
  };

  // const navigateToPackagePlan = () => {

  //   navigate(`${config.baseUrl}packageplan`)
  // }

  return (
    <>
      <div className="lighttheme overflow-hidden hero" style={{ minHeight: "100vh" }} >
        <section className="herobanner position-relative text-white overflow-hidden" style={{backgroundColor:"black"}}>
          <Container>
            <Row className="align-items-center">
              <div className="jovitClass"
                dangerouslySetInnerHTML={{
                  __html: termsandconditionlist.termsAndCondition,
                }}
              />
            </Row>
          </Container>
        </section>
      </div>

      
    </>
  );
};
export default TermsAndConditions;
